import ConsoleApi from "@/consoleapi/consoleApi";

import {AxiosResponse} from "axios";
/**
 *
 */
export default class Invoice extends ConsoleApi {
    protected readonly resource = '/invoices';

    /**
    * @param accountId
    */
    public show(accountId: string): Promise<AxiosResponse> {
      return this.axios.get(this.requestUri + this.getAccountResource(accountId),
      {
          headers: {
              Authorization: `Bearer ${this.bearerToken}`,
          }
      });
    }
}